export const COHORT_CHAR = 'C'
export const ROW_SIZE = 9;
export const COLUMN_SIZE = 9;
export const SEAT_CONSTANT = 19.1 / 12;
export const SEAT_LENGTH_TO_WIDTH_RATIO = 2;